module.exports = __webpack_public_path__ + "img/comp_open.14bd1923.png";